import React, {memo} from 'react';
import styled, {css} from 'styled-components';

import StarMaskElement from '../../../../assets/src/masks/starFilled.svg';

export type FillingOptions =
  | {
      type: 'fill';
      color: string;
    }
  | {
      type: 'mid';
      fillColor: string;
      emptyColor: string;
      breakingPoint: number;
    };

interface StarWithFillingProps {
  color: FillingOptions;
  isSelected: boolean;
}

export const StarWithFilling = memo<StarWithFillingProps>((props) => (
  <StyledStarMask data-testid={props.isSelected ? 'starFilled' : 'star'} $color={props.color} />
));

interface StyledStarMaskProps {
  $color: FillingOptions;
}

const StyledStarMask = styled.div<StyledStarMaskProps>`
  mask-position: 0 0;
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  height: 20px;
  width: 20px;
  mask-image: url(${StarMaskElement});
  ${(p) => createBackgroundGradient(p.$color)};
`;

function createBackgroundGradient(color: FillingOptions) {
  if (color.type === 'fill') {
    return css`
      background: ${color.color};
    `;
  }

  const breakingPoint = color.breakingPoint * 100;

  return css`
    background: linear-gradient(
      90deg,
      ${color.fillColor} ${breakingPoint}%,
      ${color.emptyColor} ${breakingPoint}%,
      ${color.emptyColor}
    );
  `;
}
